import { FC } from 'react';
import { useStore } from '@hooks/useStore';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { Button } from '@components/Core/Button';
import { confirmationPopupTranslations } from './translations';
import { ConfirmationPopupTransFields, IConfirmationPopupProps } from './types';

export const ConfirmationPopup: FC<IConfirmationPopupProps> = ({ onAccept, text, title }) => {
  const {
    popupStore: { closePopup },
  } = useStore();

  const { t } = useMyTranslations<ConfirmationPopupTransFields>([
    confirmationPopupTranslations.name,
  ]);

  return (
    <div className="flex flex-col justify-stretch items-center gap-y-[16px]">
      <p className="default-text mb-[8px]">{title}</p>
      <p className="default-text text-[#414042CC] mb-[16px] text-center">{text}</p>
      <Button text={t('acceptText')} onClick={onAccept} />
      <Button text={t('cancelText')} onClick={closePopup} styleType="secondary" />
    </div>
  );
};
